import { Pagination } from './pagination';
import { EspecialidadeMedica } from './especialidade-medica';
import { Procedimento } from './procedimento';

export class SearchResult {
   pagination: Pagination;
   especialidadeMedica: EspecialidadeMedica[];
   procedimentos: Procedimento[];
}
